export { default as ViewListSolidIcon } from './ViewListSolidIcon';
